<template>
  <v-app>
    <Spinner v-if="$store.state.fetchingData"/>
    <Header :roles="roles" />
    <v-content 
      style="background-color: rgb(222, 228, 242);"
      >
      <router-view @login="setRoles"></router-view>
      <v-snackbar
        v-model="showSuccessEmail"
        multi-line
        :color="successEmail ? 'success' : 'error'"
        :timeout="10000"
      >
        E-Mail(s) {{ successEmail ? 'wurde(n) erfolgreich versandt': 'konnte(n) nicht versandt werden'}} 
      </v-snackbar>
      <v-snackbar
        style="z-index: 1000000000;"
        v-model="showSnackbar"
        multi-line
        :timeout="10000"
      >
        {{snackbarMsg}}
      </v-snackbar>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Header from './shared/Header'
import Spinner from './shared/Spinner'
import Footer from './shared/Footer'

export default {
  name: 'App',
  components: {
    Spinner,
    Header,
    Footer,
  },
  data: () => ({
    userRoles: [],
    showSuccessEmail: false,
    successEmail: false,

    showSnackbar: false,
    snackbarMsg: ''
  }),
  computed: {
    roles() {
      return this.userRoles
    },
    currentRole() {
      return this.$store.state.userRole
    }

  },
  methods: {
    setRoles(roles) {
      
      const clients = JSON.parse(JSON.stringify(this.$store.state.clients));

      if(!clients) return [];
      
      let preparedClients = [];

      for(let client of clients) {
        for(let role of client.roles) {
          preparedClients.push({
            text: client.clientName + ' | ' + role,
            role,
            clientName: client.clientName,
            clientId: client.clientId
          });
        }
      }

      if(!this.currentRole) {
        this.$store.commit("setUserRole", preparedClients[0])
      }
    },
    updateLocation(clientId) {
        this.$router.push({name: this.$route.name, params: { clientId, clientId}})
    },
    fetchDataUser() {
        let self = this;
        this.axios.axiosCall({
          url: actionUrl + "rest/user/info",
          data: {},
          blockGui: false,
          success: (response) => {
            self.setUser(response.data)
          }
        })
      },
      setUser(user) {
        this.$store.commit('setUser', user)
        //this.visibleUserEditDialog = false;
      },
    fetchRoles() {
      let self = this;
      this.axios.axiosCall({
        url: actionUrl + "rest/auth/checkLogin",
        data: this.login,
        blockGui: false,
        success: function(response) {
            self.$store.commit('setDefaultState');
            self.fetchDataUser();

            if(!response.data.authenticated){
              self.$router.push({ name: 'Login', params: { clientId: self.$route.params.clientId ? self.$route.params.clientId : undefined } })
            } else {

              let responseClientIds = response.data.clients.map(client => client.clientId)
              self.$store.commit('setClients', response.data.clients)

              if(response.data.clients[0] != self.$store.state.currentClient) {
                if(self.$route.params.clientId) {
                  
                  const filterdClients = response.data.clients.filter(client => client.clientId == self.$route.params.clientId)
                  const clientsContainsClient = filterdClients.length > 0;
                  if(clientsContainsClient) {
                    const client = filterdClients[0]

                    const preparedClient = {
                      text: client.clientName + ' | ' + client.roles[0],
                      role: client.roles[0],
                      clientName: client.clientName,
                      clientId: client.clientId
                    }
                    self.$store.commit('setCurrentClient', client)
                    self.$store.commit("setUserRole", preparedClient)
                    self.updateLocation(client.clientId);
                  } else {
                    self.$store.commit('setCurrentClient', response.data.clients[0])
                    self.updateLocation(response.data.clients[0].clientId);
                  }
                } else {
                  self.$store.commit('setCurrentClient', response.data.clients[0])
                  self.updateLocation(response.data.clients[0].clientId);
                }
              }
              
              self.setRoles(response.data.roles)
              self.$store.commit('setAuthentication', response.data.authenticated)
              EventBus.$emit('authenticated');
            }
        }
      })
    },
  },
  beforeCreate() {
    let self = this

    console.log(this.$route)
    
    if(
      !self.$route.path.includes("registration") 
      && !self.$route.path.includes("password")
      && window.location.hash.includes("dashboard")
      && !window.location.hash.includes("registration")
      && !window.location.hash.includes("password")
    ) {
      console.log('asd')
      this.axios.axiosCall({
        url: actionUrl + "rest/auth/checkLogin",
        data: this.login,
        blockGui: false,
        success: function(response) {

          console.log(response.data.authenticated)

          self.$store.commit('setDefaultState');

          if(!response.data.authenticated){
              self.$router.push({ name: 'Login', params: { clientId: self.$route.params.clientId ? self.$route.params.clientId : undefined } })
          } else {
            self.$store.commit('setClients', response.data.clients)
            if(!!self.$route.params.clientId) {
              const filterdClients = response.data.clients.filter(client => client.clientId == self.$route.params.clientId)
              const clientsContainsClient = filterdClients.length > 0;
              if(clientsContainsClient) {
                const client = filterdClients[0]

                const preparedClient = {
                  text: client.clientName + ' | ' + client.roles[0],
                  role: client.roles[0],
                  clientName: client.clientName,
                  clientId: client.clientId
                }

                self.$store.commit('setCurrentClient', client)
                self.$store.commit("setUserRole", preparedClient)
              } else {
                self.$store.commit('setCurrentClient', response.data.clients[0])
              }
            } else {
              self.$store.commit('setCurrentClient', response.data.clients[0])
            }
            
            self.setRoles(response.data.roles)
            self.$store.commit('setAuthentication', response.data.authenticated)
            EventBus.$emit('authenticated');
          }
        }
      })
    }
    
    EventBus.$on('updateRoles', (roles) => {
      self.fetchRoles();
    });

    EventBus.$on('successEmail', (success) => {
      self.showSuccessEmail = true
      self.successEmail = success
    });

    EventBus.$on('showSnackbar', (msg) => {
      self.showSnackbar = true
      self.snackbarMsg = msg
    });
  }
}
</script>

<style lang="scss">
@import "./assets/css/main.css";

body {
  background-color: rgb(91, 125, 204);
}

.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  color: #0051ce;
}

</style>

<style scoped>
.v-content {
  background-color: #fff;
}
</style>

